import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
// ICONS
import { WhatsAppIcon } from "@/public/icons/icons";
import { NextSeo } from "next-seo";

function Contact() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation("contact");

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("contacts")}
        description={""}
        openGraph={{
          type: "website",
          title: t("contacts"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/contact`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0" style={{ maxWidth: "80rem" }}>
          <div>
            <h1 className="fs-1 fw-semibold text-center text-md-start text-uppercase">{t("title")}</h1>
            <div className="d-flex flex-column justify-content-center text-center pb-4 py-5">
              <div className="d-flex flex-column pb-4">
                <a className="fw-semibold" href={`https://wa.me/${process.env.shopInfo["Contatti"].WhatsApp}`} target="_blank" rel="noreferrer">
                  <span>
                    <WhatsAppIcon width={24} height={24} color="black" strokeWidth={0.1} />
                  </span>
                  <span className="ps-2 text-uppercase">{t("whatsapp.title")}</span>
                </a>
              </div>
              <div className="d-flex flex-column pb-4">
                <span className="fw-semibold text-uppercase">{t("phone.title")}</span>
                <a style={{ cursor: "pointer" }} onClick={() => (window.location.href = `tel:${process.env.shopInfo["Contatti"].Telefono}`)}>
                  {process.env.shopInfo["Contatti"].Telefono}
                </a>
                <span>{t("phone.text")}</span>
              </div>
              <div className="d-flex flex-column pb-4">
                <span className="fw-semibold text-uppercase">{t("email.title")}</span>
                <a style={{ cursor: "pointer" }} onClick={() => (window.location.href = `mailto:${process.env.shopInfo["Contatti"].Email}`)}>
                  {process.env.shopInfo["Contatti"].Email}
                </a>
              </div>
              <div className="d-flex flex-column pb-4">
                <span className="fw-semibold text-uppercase">{t("opening-hours.title")}</span>
                <span>{t("opening-hours.text1")}</span>
                <span>{t("opening-hours.text2")}</span>
                <span>{t("opening-hours.text3")}</span>
                <span>{t("opening-hours.text4")}</span>
              </div>
              <div className="d-flex flex-column pb-4">
                <span className="fw-semibold text-uppercase">{t("social-media.title")}</span>
                {/* <a  href="https://www.facebook.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
                  Facebook
                </a>
                <a  href="https://www.twitter.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
                  Twitter
                </a> */}
                <a href="https://www.instagram.com/kesy_pronto_moda/" target="_blank" rel="noreferrer">
                  {t("social-media.text")}
                </a>
                {/* <a  href="https://youtube.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
                  Youtube
                </a> */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "header", "footer", "contact", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(Contact);
